import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';

import { useUser } from '../../store/UserProvider';

import styleClasses from '../css/mobile/Header.module.scss';

const HeaderLinkItem = ({ mobileMenuItemsClass, clickOnMobile }) => {
  const { user } = useUser();

  let location = useLocation();
  let currentLocation = location.pathname;
  let locationArray   = currentLocation.split('/');
  let firstValue      = locationArray.length > 1 ? locationArray[1] : '/';
  
  return (
    <nav className={`${ styleClasses.mainNavigation} ${ mobileMenuItemsClass }`}>
      <ul>
        <li>
          <Link to="/" className={ currentLocation === '/' ? styleClasses.active : '' } onClick={ clickOnMobile }>HOME</Link>
        </li>
        <li>
          <Link to="/musicard" className={ firstValue === 'musicard' ? styleClasses.active : '' } onClick={ clickOnMobile }>MUSICARD</Link>
        </li>
        {/*<li>
          <Link to="/about-us" className={ firstValue === 'about-us' ? styleClasses.active : '' } onClick={ clickOnMobile }>ABOUT US</Link>
        </li>*/}
        {
          user
          ? 
          <li><Link to="/my-page" className={ firstValue === 'my-page' ? styleClasses.active : '' } onClick={ clickOnMobile }>MY PAGE</Link></li>
          :
          <li><Link to="/login" className={ firstValue === 'login' ? styleClasses.active : '' } onClick={ clickOnMobile }>LOGIN</Link></li>              
        }
      </ul>
    </nav>
  );
}

const Header = () => {
  let location  = useLocation();
  let { user }  = useUser();

  const [firstValue, setFirstValue]   = useState('');
  const [secondValue, setSecondValue] = useState('');
  const [userTab, setUserTab]         = useState(false);
  
  const [inactive, setInactive] = useState('');
  const [backButton, setBackButton] = useState(styleClasses.inactive);
  const [mobileHeaderClass, setMobileHeaderClass]           = useState('');                 // 모바일 헤더 클래스
  const [mobileOpenButtonClass, setMobileOpenButtonClass]   = useState(styleClasses.active);// 모바일 메뉴 열기 버튼 클래스
  const [mobileCloseButtonClass, setMobileCloseButtonClass] = useState('');                 // 모바일 메뉴 닫기 버튼 클래스
  const [mobileMenuItemsClass, setmobileMenuItemsClass]     = useState('');                 // 모바일 네비게이션 클래스

  const toggleMenuButton = () => {
    // 버튼
    if (mobileOpenButtonClass === styleClasses.active) {
      setMobileOpenButtonClass('');
      setMobileCloseButtonClass(styleClasses.active);
    } else {
      setMobileOpenButtonClass(styleClasses.active);
      setMobileCloseButtonClass('');
    }

    // 헤더
    if (mobileHeaderClass === styleClasses.active) {
      setMobileHeaderClass('');
    } else {
      setMobileHeaderClass(styleClasses.active);
    }

    // 메뉴
    if (mobileMenuItemsClass === styleClasses.active) {
      setmobileMenuItemsClass('');
    } else {
      setmobileMenuItemsClass(styleClasses.active);
    }
  };

  const clickOnMobile = () => {
    toggleMenuButton();
  }

  useEffect(() => {
    let currentLocation = location.pathname;
    let locationArray   = currentLocation.split('/');
    setFirstValue(locationArray.length > 2 ? locationArray[1] : '/');
    setSecondValue(locationArray.length > 2 ? locationArray[2] : null);

    if (firstValue === 'musicard') {
      setInactive(styleClasses.inactive);
      setBackButton('');
    } else {
      setInactive('');
      setBackButton(styleClasses.inactive);
    }

    const getUserInfo = async () => {
      const userRef = doc(db, "users", user.userID);
      const userSnap = await getDoc(userRef);

      if (userSnap.exists()) {
        const userData = userSnap.data();
        let musicards = [];
        
        const getMusicards = userData.musicard ? Object.values(userData.musicard) : [];
        getMusicards.forEach((value) => {
          musicards.push(value);
        });
        
        if (getMusicards.includes(secondValue)) {
          setUserTab(true);
        } else {
          setUserTab(false);
        }
      }
    }

    if (user?.userID) {
      getUserInfo();
    } else {
      setUserTab(false);
    }
  }, [firstValue, location.pathname, secondValue, user?.userID]);

  return (
    <>
      <header className={ styleClasses.headerMobile }>
        
        <div className={ styleClasses.inner }>
          <div className={`${ styleClasses.container } ${ mobileHeaderClass } ${ inactive }`}>
            <div className={ styleClasses.logo }>
              <Link to='/'>
                <img src={`${process.env.PUBLIC_URL}/assets/images/logo.webp`} alt="MusiCards" />
                <h1>Musizic</h1>
              </Link>
            </div>
            <div className={ styleClasses.mobileButton }>
              <button className={ mobileOpenButtonClass } onClick={ toggleMenuButton }>
                <div className="commonIcon mobile">
                  <i className="menuWhite w24"></i>
                </div>
              </button>
              <button className={ mobileCloseButtonClass } onClick={ toggleMenuButton }>
                <div className="commonIcon mobile">
                  <i className="closeWhite w24"></i>
                </div>
              </button>
            </div>
            <HeaderLinkItem mobileMenuItemsClass={ mobileMenuItemsClass } clickOnMobile={ clickOnMobile } />
          </div>
          <div className={`${ styleClasses.backButton } ${ backButton }`}>
            <Link to='/musicard'>
              <div className="commonIcon mobile">
                <i className='leftWhite w32'></i>
              </div>
            </Link>
            {
          userTab
          &&
          <div className={ styleClasses.fixedTab }>
            <Link to='/my-page/portfolio' state={{ musicardID: secondValue }} className="commonIcon mobile">
              <i className='plusWhite w20'></i>
              포트폴리오 만들기
            </Link>
            <Link to={`/my-page/${ firstValue }/${ secondValue }`} className="commonIcon mobile">
              <i className='pencilWhite w20'></i>
              뮤지카드 편집
            </Link>
          
          </div>
        }
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
